import { Button, Link } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import logo from "../../assets/Images/logo.png";
import * as actionTypes from "../../store/actions";
import DrawerToggleButton from "../SideDrawer/DrawerToggleButton";
import classes from "./Toolbar.module.css";
import UserMenu from "./UserMenu/UserMenu";

class Toolbar extends Component {
  render() {
    let form = this.props.user ? <UserMenu name={this.props.user.name} /> : null;

    return (
      <div>
        <div
          className={
            this.props.appMenuClass === "top"
              ? classes.ToolbarTop
              : classes.Toolbar
          }
        >
          <DrawerToggleButton click={this.props.drawerClickHandler} />
          <img src={logo} alt="logo" className={classes.Logo} />
          <div className={classes.NavBar}>
            <Link
              href="/"
              onClick={() => window.scroll(0, 0)}
              className={
                this.props.location.pathname === "/"
                  ? classes.ListItemActive
                  : classes.ListItem
              }
            >
              Početna
            </Link>
            {this.props.user && (
              <>
                <span className={classes.Separator}>|</span>
                <Link
                  href="/region"
                  onClick={() => window.scroll(0, 0)}
                  className={
                    this.props.location.pathname === "/region"
                      ? classes.ListItemActive
                      : classes.ListItem
                  }
                >
                  Region
                </Link>
              </>
            )}
            <span className={classes.Separator}>|</span>
            <Link
              href="/events"
              onClick={() => window.scroll(0, 0)}
              className={
                this.props.location.pathname === "/events"
                  ? classes.ListItemActive
                  : classes.ListItem
              }
            >
              Najava događaja
            </Link>
            <span className={classes.Separator}>|</span>
            <Link
              href="/service"
              onClick={() => window.scroll(0, 0)}
              className={
                this.props.location.pathname === "/service"
                  ? classes.ListItemActive
                  : classes.ListItem
              }
            >
              Usluge
            </Link>
            <span className={classes.Separator}>|</span>
            <Link
              href="/contact"
              onClick={() => window.scroll(0, 0)}
              className={
                this.props.location.pathname === "/contact"
                  ? classes.ListItemActive
                  : classes.ListItem
              }
            >
              Kontakt
            </Link>
          </div>

          {!this.props.user ? (
            <div className={classes.Buttons}>
              <Button
                className={classes.Button}
                onClick={this.props.hadnleTogleLogin}
                startIcon={<AccountCircleIcon style={{ fontSize: 25 }} />}
              >
                Prijavi se
              </Button>
              <span className={classes.Separator}>|</span>
              <Link href="/register">
                <Button
                  className={classes.Button}
                  startIcon={<ContactMailIcon style={{ fontSize: 25 }} />}
                >
                  Registruj se
                </Button>
              </Link>
            </div>
          ) : null}

          <div className={classes.Temp}>{form}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  hadnleTogleLogin: () => dispatch({ type: actionTypes.TOGGLE_LOGIN }),
  hadnleTogleRegistration: () =>
    dispatch({ type: actionTypes.TOGGLE_REGISTRATION }),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Toolbar));
